import React, { useState, useEffect } from 'react';
import PageHeader from 'components/common/PageHeader';
import OrderInfo from './OrderInfo';
import OrderedProducts from './OrderedProducts';
import { useTranslation, Trans } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useOrderHook from 'y4/hooks/useOrderHook';
import y from 'y4/Utils';
import OrderStatus from '../OrderStatus';

const OrderDetails = () => {
  const { t } = useTranslation('commerce');
  const params = useParams();
  const { loadOrder } = useOrderHook();
  const [order, setOrder] = useState({});
  useEffect(() => {
    loadOrder(params.id).then(rt => {
      if (rt.isOk()) {
        setOrder(rt.data);
      } else {
        y.toastError(rt.message);
      }
    });
  }, []);

  return (
    <>
      <PageHeader title={t('Order Details')} titleTag="h5" className="mb-3">
        <p className="fs--1 mt-1">
          <Trans ns="commerce">Order ID</Trans>: <strong>{order.id}</strong>{' '}
          <Trans ns="commerce">Order Time</Trans>: {order.date}
        </p>
        <div>
          <strong className="me-2">
            <Trans ns="commerce">Status</Trans>:{' '}
          </strong>
          <OrderStatus status={order.status} className={'fs--2'} />
        </div>
      </PageHeader>
      <OrderInfo order={order} />
      <OrderedProducts order={order} />
    </>
  );
};

export default OrderDetails;
